@let options = effectiveOptions();
@let readOnly = isReadOnly();

@if (accountMoves()) {

  <div class="d-flex flex-column h-100">
    <div class="row mt-2">
      <div class="col-12 col-md">
        <div class="ps-3">
          @if (!readOnly) {
            @if (options.showAddInvoice) {
              <button
                type="button"
                [class]="ButtonType.Primary | buttontypepipe"
                class="btn-sm btn"
                translate
                (click)="openModalCreateInvoiceExtended()"
              >
                ACCOUNT_MOVE_TAB_LBL_ADD
              </button>
            }
            @if (options.showBindPayment) {
              <button
                type="button"
                [class]="ButtonType.Light | buttontypepipe"
                class="btn-sm btn"
                translate
                (click)="openModalBindAccountMoves('Entry')"
              >
                PAYMENT_LBL_BIND_ACCOUNT_MOVE
              </button>
            }
            @if (options.showBindRepayment) {
              <button
                type="button"
                [class]="ButtonType.Light | buttontypepipe"
                class="btn-sm btn"
                translate
                (click)="openModalRepaymentBindAccountMoves()"
              >
                REPAYMENT_LBL_BIND_ACCOUNT_MOVE
              </button>
            }
          }
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <table class="table table-striped border-bottom">
        <thead>
        <tr>
          <th>
            <a translate>ACCOUNT_MOVE_TAB_TABLE_TYPE</a>
          </th>
          <th>
            <a translate>ACCOUNT_MOVE_TAB_TABLE_EMITTER</a>
          </th>
          <th class="text-end">
            <a translate>ACCOUNT_MOVE_TAB_TABLE_AMOUNT</a>
          </th>
          @if (options.showPeriodColumn) {
            <th>
              <a translate>ACCOUNT_MOVE_TAB_TABLE_PERIOD</a>
            </th>
          }
          <th>
            <a translate>ACCOUNT_MOVE_TAB_TABLE_NAME</a>
          </th>
          @if (options.showSlipColumn) {
            <th>
              <a translate>ACCOUNT_MOVE_TAB_TABLE_SLIP_BINDED</a>
            </th>
          }
          <th>
            <a translate>ACCOUNT_MOVE_TAB_TABLE_BINDED</a>
          </th>
          <th>
            <a translate>ACCOUNT_MOVE_TAB_TABLE_STATUS</a>
          </th>
          <th>
            <a translate>PAYMENT_LBL_ACTIONS</a>
          </th>
          <th>
            <a translate>ACCOUNT_MOVE_TAB_TABLE_REPAYMENT_BINDED</a>
          </th>
        </tr>
        </thead>

        <tbody>
          @for (accountMove of accountMoves(); track accountMove.id) {
            <ng-container
              class="row-action"
            >
              @for (accountMoveLine of accountMove.accountMoveLines; track accountMoveLine.id) {
                <tr
                >
                  <td>{{ accountMove.name }}</td>
                  <td>{{ isClient() ? accountMove.companyOrBrokerAccountName : accountMove.clientAccountName }}</td>
                  <td class="text-end">
                    <app-colored-amount [amountValue]="accountMoveLine.unitPriceClientView"/>
                  </td>
                  @if (options.showPeriodColumn) {
                    <td>
                      {{ accountMove.period | accountMovePeriod }}
                    </td>
                  }
                  <td>
                    {{ accountMove.reference }}
                  </td>
                  @if (options.showSlipColumn) {
                    <td>
                      @if (accountMove.journalName &&
                      accountMove.journalId) {
                        <a
                          role="button"
                          class="link-primary border-0 bg-transparent"
                          (click)="
                      openModalBindSlipDetails(
                        accountMove,
                        accountMove.journalId,
                        accountMove.journalName
                      )
                    "
                          translate
                        >{{ accountMove.journalName }}
                        </a>
                      }
                    </td>
                  }
                  @if (accountMove.payingAccountMoves.length == 0) {
                    <td>
                      <!--                @if (!accountMove.isReadOnly) {-->
                      @if (isClient()) {
                        <a
                          role="button"
                          class="link-primary border-0 bg-transparent"
                          (click)="
                    openModalBindAccountMoves(
                      'Entry',
                      accountMove.id
                    )
                  "
                          translate
                        >PAYMENT_LBL_BIND_PAYMENT</a
                        >
                        @if (accountMove.directionSign === -1) {
                          <span> | </span>
                          <a
                            role="button"
                            class="link-primary border-0 bg-transparent"
                            (click)="
                    openModalCreateAndBindPayment(
                      accountMove.id,
                      false,
                      accountMoveLine.unitPrice,
                      accountMove.creditAccountId
                    )
                  "
                            translate
                          >PAYMENT_LBL_CREATE_AND_BIND_PAYMENT</a
                          >
                        }
                      }
                      <!--                }-->
                    </td>
                  }
                  @if (accountMove.payingAccountMoves.length > 0) {
                    <td>
                      @if (isClient()) {
                        <a
                          role="button"
                          class="link-primary border-0 bg-transparent"
                          (click)="
                    openModalBindAccountMovesDetails(
                      accountMove,
                      'Payment',
                      accountMove.isReadOnly,
                      accountMove.isAdminOnly
                    )
                  "
                          translate
                        >{{
                            accountMove.payingAccountMoves
                              | showPaymentAndTruncate : [50]
                          }}
                        </a>
                      } @else {
                        @if (accountMove.accountMoveTypeId ===
                        SALES_PERSON_COMMISSION_ID) {
                          <a
                            role="button"
                            class="link-primary border-0 bg-transparent"
                            (click)="
                    openModalBindAccountMovesDetails(
                      accountMove,
                      'Payment',
                      accountMove.isReadOnly,
                      accountMove.isAdminOnly
                    )
                  "
                            translate
                          >{{
                              accountMove.payingAccountMoves
                                | showPaymentAndTruncate : [50]
                            }}
                          </a>
                        } @else {
                          <a
                            role="button"
                            class="link-primary border-0 bg-transparent"
                            (click)="
                    openModalBindAccountMovesDetails(
                      accountMove,
                      'Slip',
                      false,
                      accountMove.isAdminOnly
                    )
                  "
                            translate
                          >{{
                              accountMove.payingAccountMoves
                                | showPaymentAndTruncate : [50]
                            }}
                          </a>
                        }
                      }
                    </td>
                  }
                  <td>
                    {{ accountMove.statusLoc }}
                  </td>
                  <td>
                    @for (action of accountMove.actions; track action.name + action.actionName; let last = $last) {
                      <a
                        role="button"
                        class="link-primary border-0 bg-transparent"
                        (click)="
                      triggerAction(
                        action.name,
                        accountMove.id
                      )
                    "
                        translate
                      >{{ action.actionName }}{{ last ? "" : " | " }}</a
                      >
                    }
                  </td>
                  @if (accountMove.repaymentAccountMoves.length == 0) {
                    <td>
                      @if (!accountMove.isReadOnly) {
                        <a
                          role="button"
                          class="link-primary border-0 bg-transparent"
                          (click)="
                    openModalRepaymentBindAccountMoves(
                      accountMove.id
                    )
                  "
                          translate
                        >REPAYMENT_LBL_BIND_ACCOUNT_MOVE</a
                        >
                      }
                    </td>
                  }
                  @if (accountMove.repaymentAccountMoves.length > 0) {
                    <td>
                      <a
                        role="button"
                        class="link-primary border-0 bg-transparent"
                        (click)="
                    openModalBindAccountMovesDetails(
                      accountMove,
                      'Repayment',
                      false,
                      accountMove.isAdminOnly
                    )
                  "
                        translate
                      >{{
                          accountMove.repaymentAccountMoves
                            | showRepaymentAndTruncate : [50]
                        }}
                      </a>
                    </td>
                  }
                </tr>
              }
            </ng-container>
          }
        </tbody>
      </table>
    </div>
  </div>

}
